<template>
    <v-form>
        <v-card>
            <v-card-title>
                <span class="headline">Lab Selection</span>
            </v-card-title>

            <v-card-text>
                <autocomplete v-model="labId" label="Lab" placeholder="Select the shipping label's lab" item-text="label" item-value="id" :url="'/api/Labs/Autocomplete'" :filter="filter" />
            </v-card-text>

            <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn color="quaternary" text @click="$emit('cancel')">Cancel</v-btn>
                <v-btn color="quaternary" text @click="select">Select</v-btn>
            </v-card-actions>
        </v-card>
    </v-form>
</template>

<script>
    export default {
        props: [
            'filter',
        ],

        components: {
            autocomplete: () => import('@/components/Autocomplete')
        },

        data() {
            return {
                labId: null,
            }
        },

        methods: {
            select() {
                this.$emit('input', this.labId);
            }
        },
    };
</script>
